import React from "react";
import { WebBuilder } from "../../components";

export default function PageBuilder() {

    return (
        <WebBuilder/>
    )
}